module.exports = __webpack_public_path__ + "static/media/merise_icon_store.51b9f633.png";